import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/sonomo.webp';
import screenshot_target from '../../../images/letterfunnel/samehalfar.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Sameh Alfar"
      firstname="Sameh"
      companyname="Sonomo"
      competition="ANOTE en Royalty Exchange"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/samehalfar.js